import React from 'react';
import BusinessEventSlider from "../BusinessEventSlider";
import './Bannoun.css';

export default function Bannoun() {
  return (
    <div className="announcements-page">
      <BusinessEventSlider /> {/* Insert the slider component here */}
    </div>
  );
}
